var _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBackpic3 = function SvgBackpic3(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32741_39604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4443 42.2402C15.9778 42.0972 16.2944 41.5489 16.1515 41.0154C16.0085 40.482 15.4602 40.1654 14.9267 40.3083C14.3932 40.4513 14.0767 40.9996 14.2196 41.5331C14.3625 42.0665 14.9109 42.3831 15.4443 42.2402Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1717 40.1696C23.7052 40.0267 24.0218 39.4783 23.8788 38.9449C23.7359 38.4114 23.1876 38.0948 22.6541 38.2378C22.1206 38.3807 21.804 38.929 21.947 39.4625C22.0899 39.996 22.6383 40.3126 23.1717 40.1696Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0582 26.9241L6.43894 26.0182C6.43894 26.0182 7.31104 27.6775 7.86984 28.7406C8.98641 30.865 10.52 33.7827 11.4197 35.4945C11.8546 36.3219 12.8038 36.7361 13.7067 36.4941L22.0011 34.2717C22.9065 34.029 23.5219 33.1901 23.4815 32.2536L23.1532 24.6455",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1532 24.6455L8.1813 28.6572",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32741_39604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8076 26.2121L65.9313 29.7476L59.8076 26.2121ZM60.6048 19.528C61.8555 24.1958 59.0854 28.9938 54.4176 30.2445C49.7498 31.4952 44.9518 28.7252 43.7011 24.0573C42.4503 19.3895 45.2204 14.5915 49.8883 13.3408C54.5561 12.0901 59.354 14.8602 60.6048 19.528Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32741_39604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.349884 24.5439) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32741_39604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(38.9869 14.1912) rotate(-15)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackpic3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backpic3.71f85ac3.svg";
export { ForwardRef as ReactComponent };